import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'card-icon-social-component',
    templateUrl: './card-icon-social.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CardIconSocialComponent {

  @Input() icon: string;
  @Input() title: string;

  constructor() { }

  ngOnInit() {

  }
}
